module.exports = __webpack_public_path__ + "static/bg_crb-461eaf167c69fbc0f3f07215e2b121fc.jpg";